export default __webpack_public_path__ + "static/media/box_gray.a836bb2f.svg";